import axios from '@/libs/api.request';
import search from '@/libs/search';
import axiosRequest from 'axios';

export const getCompanyList = data => {
    return axios.request({
        url: 'api/systemManagement/companyManagement/getCompanyList',
        data: data,
        method: 'post'
    });
};

export const createCompany = data => {
    return axios.request({
        url: 'api/systemManagement/companyManagement/createCompany',
        data: data,
        method: 'post'
    });
};

export const updateCompany = data => {
    return axios.request({
        url: 'api/systemManagement/companyManagement/updateCompany',
        data: data,
        method: 'post'
    });
};

export const deleteCompany = data => {
    return axios.request({
        url: 'api/systemManagement/companyManagement/deleteCompany',
        data: data,
        method: 'post'
    });
};
